import { Grid } from "@mui/material";
import React from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header } from "../../Components/Header/Header";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import WSLoadingOverlay from "../../Components/WSLoadingOverlay";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { UpdateStatus } from "../components/UpdateStatus";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import config from '../../Config/clientConfig.json';

const QuotationList: React.FC<any> = React.memo((props) => {
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);
  // const [loading,setLoading] = React.useState(false);
  const [quotationId,setQuotationId] = React.useState(null);

  const source = {
    url: "quotations/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  //edit / delete or perform other actions.
  const handleAction = async(action: string, row: any) => {
    if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    }else if(action === "Change Status"){
     setQuotationId(row?._id);
    }
  };

  
    const handleStatus = async (data: any) => {
      try {
        // setLoading(true);
        const response: any = await saveData(data);
        setQuotationId(null);
  
        if (response && response?.message) {
          dispatch(resetDataComponent("quotationGrid"));
          showMessage(
            response.message,
            response.success === true ? "success" : "error"
          );
        }
      } catch (e: any) {
        if (e.message === 'GlobalHandledError') return;
        showMessage(e.response?.data?.message || "An unexpected error occurred","error");
      } finally {
        setQuotationId(null);
        
      }
    };
  
    const metadataStatus: IMetaData = {
      title: "Update Status",
      hideActions: false,
      content: (props: any, row: any) => <UpdateStatus {...props} config={config.quotationStatusConfig.staticOptionData}/>,
      actions: [
        {
          label: "Cancel",
          className: "ws-cancel",
          type: "button"
        },
        {
          label: "Submit",
          onClick: handleStatus,
          type: "submit",
          autoFocus: true
        }
      ],
      isDragable: true
    };
  
    const saveData = async (data: any) => {
      const request: any = {
        status: data?.newStatus,
      };
  
      const response: any = await callAPI(
        `quotations/update/${quotationId}/status`,
        Method.PATCH,
        request
      );
      console.log("response from status",response);
      return response;
    };
  
    const handleCloseDialog = (data?: any) => {
      setQuotationId(null);
    };
    
    React.useEffect(() => {
      if (quotationId) {
        openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
      }
    }, [quotationId]);


  const handleDelete = () => {
    dispatch(resetDataComponent("quotationGrid"));
    showMessage("Quotation deleted successfully!", "success");
  };

  const columns: IColumns[] = [
    {
      header: "Customer Name",
      fieldName: "client.name",
      tooltip: true,
      sortable: true
    },

    {
      header: "Title",
      fieldName: "title",
      tooltip: true,
      sortable: true
    },
    
    {
      header: "Created Date",
      fieldName: "createdAt",
      tooltip: true,
      type: "date"
    },

    {
      header: "Grand Total",
      fieldName: "total",
      tooltip: true,
      sortable: true
    },

     {
      header: "Status",
      fieldName: "status",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Delete", "Change Status"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  return (
    <>
      <Helmet>
        <title>Quotations | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all your quotations in one place. View, add, or delete quotation information easily."
        />
      </Helmet>
      <Grid p={2}>
        <Header
          type="dashboard"
          title="Quotations"
          id={"quotationHeader"}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="quotationGrid"
              columns={columns}
              source={source}
              exportCsv
            />
          </Grid>
        </Grid>

        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"quotations/delete"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this quotation?"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
            permanent
          />
        )}
      </Grid>
    </>
  );
});


export default QuotationList;